// News页面相关数据
// 按规则修改和添加内容即可，请不要更改数据结构以及变量命名
export const newsData = {
    newsList: [
        // 每一条新闻
        "Sep 2023: One paper got accepted at NeurIPS 2023!",
        "May 2023: Two papers ([1][2]) are accepted at ACL 2023!",
        "Mar. 2023: Yunchong Song has got the ICLR Travel Award, congratuations!",
        "Feb. 2023: Two papers ([1][2]) are accepted at ICASSP 2023!",
        "Jan. 2023: One paper is accepted at ICLR 2023!",
        "Oct. 2022: Three papers ([1][2][3]) are accepted at EMNLP 2022!",
        "Feb. 2022: Two papers ([1][2]) are accepted at ACL 2022!",
    ],
}